import { analytics } from '../config/firebase'
import { logEvent } from 'firebase/analytics'

/**
 * Track page view events
 */
export const trackPageView = (pageName: string) => {
    logEvent(analytics, 'page_view', {
        page_name     : pageName,
        page_location : window.location.href,
    })
}

/**
 * Track custom events
 */
export const trackEvent = (eventName: string, params?: Record<string, any>) => {
    logEvent(analytics, eventName, params)
}

/**
 * Track user actions with category and label
 */
export const trackUserAction = (action: string, category: string, label?: string) => {
    logEvent(analytics, 'user_action', {
        action,
        category,
        label,
    })
}

/**
 * Track error events
 */
export const trackError = (error: string, details?: Record<string, any>) => {
    logEvent(analytics, 'error', {
        error,
        ...details,
    })
}